<template>
	<form
		class="location-search form-inline"
		@submit.prevent="citySelected"
	>
		<div class="dropdown">
			<input
				id="location-tf"
				ref="locationInput"
				v-model="location"
				:placeholder="placeholder"
				:class="{'error' : error}"
				class="form-control"
				name="city"
				type="text"
				autocomplete="off"
				@input="searchLocation"
				@keyup="keyPress"
			>
			<div
				v-if="(locations.length && !selected) || error"
				id="locations_dd"
				class="dropdown-menu"
				tabindex="1"
				@keydown="keyPress"
			>
				<span
					v-if="locations.length"
					:class="{'error' : error}"
					class="dropdown-item item-header"
				>
					Please make a selection:
				</span>
				<span
					v-if="!locations.length"
					:class="{'error' : error}"
					class="dropdown-item item-header"
				>
					No locations found
				</span>
				<a
					v-for="(next_item, index) in locations"
					:key="index"
					:class="[(focused_index == index ? 'focused_item' : '')]"
					class="dropdown-item"
					@click="selectCity(next_item)"
				>
					{{ next_item.value }} {{ extended_search ? next_item.zipcode : '' }}
				</a>
			</div>
		</div>
		<button
			type="submit"
			class="btn"
		>
			{{ !searching ? buttonText : '' }}
			<div
				v-if="searching"
				class="loader"
			/>
		</button>
	</form>
</template>

<script>
import { filter } from 'lodash-es';

export default {
	// eslint-disable-next-line
	props: ['type', 'buttonText', 'placeholder', 'onSelect'],
	data: function() {
		return {
			error: false,
			selected: false,
			searching: false,
			extended_search: false,
			location: '',
			locations: [],
			selectedCity: {},
			focused_item: {},
			focused_index: -1,
			ii: 0,
			elems: [],
		};
	},
	computed: {
		locationLastWordIndex: function() {
			return this.location.lastIndexOf(' ');
		},
	},
	mounted: function() {
		this.$log.debug('location type', this.type);
		this.checkForQuoteData();

		this.searchLocation = this.$iUtils.debounce(this.searchLocation, 250);
		this.$nextTick(() => {
			this.$refs.locationInput.focus();
		});

		this.checkForInitialLoc();
	},
	methods: {
		checkForQuoteData: function() {
			const quote = this.$store.state.quote;

			if (!this.$iUtils.isEmpty(quote[this.type])) {
				this.selectedCity = quote[this.type];
				this.location = this.selectedCity.value;
				this.selected = true;
			}
		},
		checkForInitialLoc: function() {
			const initial_loc = this.$session.get('initial_loc') || '';

			if (initial_loc && initial_loc.length) {
				this.location = initial_loc;
				this.searchLocation();
			}
		},
		searchLocation: function() {
			this.error = false;
			this.selected = false;

			if (this.location.length >= 2) {
				this.extended_search = this.isExtendedSearchNeeded();
				const location = this.extended_search
					? this.location.substring(0, this.locationLastWordIndex)
					: this.location;

				let url = 'service/location?query=' + location.substr(0, 25);

				url += this.extended_search ? '&extended=1' : '';

				url = this.extended_search ? url + '&extended=1' : url;

				this.searching = true;
				this.$ireloApi.get(url).then(
					resp => {
						this.searching = false;
						this.locations = resp.data;

						if (!this.locations.length) {
							this.error = true;
						} else if (this.extended_search) {
							this.matchSingleLocation(
								this.location.substr(
									this.locationLastWordIndex + 1
								)
							);
						} else if (!isNaN(this.location)) {
							this.matchSingleLocation(this.location);
						} else if (this.locations.length === 1) {
							this.selectCity(this.locations[0]);
						}
					},
					errorResp => {
						this.searching = false;
						this.$log.error(errorResp);
						this.$toastr(
							'error',
							'Something went wrong. Please refresh and try again.',
							'Error!'
						);
					}
				);
			} else {
				this.locations = [];
			}
		},
		isExtendedSearchNeeded: function() {
			let extended_search = false;
			const location = this.location.split(' ');

			if (location.length > 1) {
				extended_search = !isNaN(
					parseInt(location[location.length - 1])
				)
					? true
					: false;
			}

			return extended_search;
		},
		matchSingleLocation: function(searchValue) {
			const isZipcode = !isNaN(searchValue);
			const searchLocation = searchValue
				.replace(/[.,]+/, '')
				.replace(/\s\s+/, ' ')
				.toLowerCase();

			this.$nextTick(() => {
				// Get all locations that match the given location
				const matches
					= filter(this.locations, loc => {
						if (!loc) {
							return false;
						}

						let location = '';

						if (isZipcode) {
							location = loc.zipcode;
						} else {
							location = loc.value
								.replace(/[.,]+/, '')
								.toLowerCase();
						}

						if (!location) {
							return false;
						}

						// Zipcode needs to be a string in case it starts with '0'
						return location.includes(String(searchLocation));
					}) || [];

				if (!matches.length) {
					return;
				}

				const autoSelect
					= (!this.extended_search
						&& isZipcode
						&& matches.length <= 3)
					|| matches.length === 1;

				this.$log.debug(
					'matchSingleLocation | ',
					searchLocation,
					this.locations,
					matches,
					this.extended_search,
					autoSelect
				);

				// Select the first location from dropdown if only three locations
				// were found with the given zipcode
				if (autoSelect) {
					this.selectCity(matches[0]);
				}
			});
		},
		async selectCity(item) {
			this.selectedCity = item;

			if (this.$iUtils.isEmpty(this.selectedCity)) {
				return false;
			}

			this.$log.info('selectedCity->', this.selectedCity);

			this.location = this.selectedCity.value;
			this.selected = true;

			try {
				if (this.type === 'origin') {
					await this.$store.dispatch('quote/update', {
						origin: this.selectedCity,
					});
				} else {
					await this.$store.dispatch('quote/update', {
						destination: this.selectedCity,
					});
				}

				this.cleaner();

				// Give some time for the user to see which city was selected
				setTimeout(() => {
					this.citySelected();
				}, 250);
			} catch (err) {
				this.$log.error(err);
				this.$toastr('error', 'Something went wrong, please refresh and try again.', 'Error!');

				return false;
			}

			return true;
		},
		citySelected: function() {
			if (this.selected) {
				this.onSelect();
				this.error = false;
			} else {
				this.error = true;
				this.showError();
			}
		},
		showError: function() {
			const ele = document.getElementById('locations_dd');

			if (ele) {
				ele.scrollTop = 0;
			}
		},
		keyPress: function(event) {
			if (!isNaN(this.location) && this.location.length > 5) {
				const searchStr = this.location.substring(0, this.location.length - 1);

				this.location = searchStr;
			}

			if (!this.locations || !this.locations.length) {
				return false;
			}

			const dropDown = document.getElementById('locations_dd');

			if ((event.keyCode === 40 || event.keyCode === 38) && this.ii < 1) {
				this.elems = document.getElementsByClassName('dropdown-item');
				document.activeElement.blur();
				this.$nextTick(() => {
					if (dropDown) {
						dropDown.focus();
					}
				});

				this.ii++;
			}

			if (event.keyCode === 40) {
				const i
					= this.focused_index < this.locations.length - 1
						? ++this.focused_index
						: this.focused_index;

				dropDown.scrollTop = this.elems[i + 1].scrollHeight * i;
				this.focused_item = this.locations[i];
			} else if (event.keyCode === 38) {
				const j
					= this.focused_index > 0
						? --this.focused_index
						: this.focused_index;

				dropDown.scrollTop = this.elems[j + 1].scrollHeight * j;
				this.focused_item = this.locations[j];
			} else if (event.keyCode === 13) {
				this.selectCity(this.focused_item);
			}

			return true;
		},
		cleaner: function() {
			this.focused_index = -1;
			this.focused_item = {};
			this.elems = [];
		},
		isZipCode: function() {
			if (this.location && this.location.match(/^[0-9]+$/) != null) {
				return true;
			}

			return false;
		},
	},
};
</script>

<style lang="scss">
@import "~@/../node_modules/bootstrap/scss/bootstrap-reboot";

@-moz-document url-prefix() {
	.location-search button {
		font-size: 1.3rem !important;
	}
}
.location-search.form-inline {
	justify-content: center;
	margin: 20px 0;
}

.location-search .dropdown {
	display: inline-block;
	height: 45px;
	margin-right: 20px;
	vertical-align: middle;
	width: 55%;
}

.location-search input {
	background: white;
	font-size: 1.5rem;
	height: 100%;
	width: 100% !important;
}

.location-search input:focus {
	border: 1.5px solid #3bb671;
}

.location-search input.error {
	border: 1.5px solid #d40f27;
}

.location-search a.error {
	color: #d40f27 !important;
}

.location-search .dropdown-menu {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	display: block;
	margin-top: -1px;
	max-height: 300px;
	overflow-x: hidden;
	overflow-y: auto;
	padding: 0;
	width: 100%;
}

.location-search .dropdown-item {
	border-bottom: 1px solid #f0f0f0;
	color: black;
	cursor: pointer;
	display: block;
	font-size: 1.2rem;
	padding: 10px 15px;
	text-decoration: none;
}

.location-search .dropdown-item:hover {
	background-color: #3bb671;
}
.location-search .dropdown-item:not(.item-header):hover {
	color: white !important;
}

.location-search .focused_item {
	background-color: #3bb671;
	color: white !important;
}

.location-search .dropdown-item.item-header {
	font-weight: normal;
}

.location-search .dropdown-item.item-header.error:hover {
	color: red;
}

.location-search .dropdown-item.item-header:hover {
	background: transparent;
}

.location-search .option-show {
	border: 2px solid #f88379;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.location-search button {
	border-radius: 40px;
	width: 40%;
}

@include media-breakpoint-down(sm) {
	.location-search .dropdown {
		margin-bottom: 10px;
		margin-right: 0;
		width: 100%;
	}

	.location-search button {
		width: 100%;
	}
}
</style>
